export enum UserRegistrationStatus {
  PENDING_USER_CREATION = 'PENDING_USER_CREATION',
  PENDING_USER_ACCOUNT_CONFIRMATION = 'PENDING_USER_ACCOUNT_CONFIRMATION',
  COMPLETED = 'COMPLETED',
}

export enum UserRegistrationType {
  INVITATION = 'INVITATION',
  SUBSCRIPTION_PURCHASE = 'SUBSCRIPTION_PURCHASE',
}

export enum UserRegistrationError {
  EMAIL_TAKEN = 'EMAIL_TAKEN',
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
}

export enum ConfirmUserRegistrationError {
  EXPIRED_CODE = 'EXPIRED_CODE',
  INVALID_CODE = 'INVALID_CODE',
  INVALID_LINK = 'INVALID_LINK',
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
}

export enum ResendUserRegistrationError {
  INCOMPLETE_REGISTRATION = 'INCOMPLETE_REGISTRATION',
  INVALID_LINK = 'INVALID_LINK',
}

export enum RegisterUserConfirmationMethod {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
}

export interface UserRegistrationIntentResponse {
  anonymizedConfirmationCodeRecipient?: string;
  confirmationMethod?: RegisterUserConfirmationMethod;
  email: string;
  registrationToken: string;
  registrationStatus: UserRegistrationStatus;
  registrationType: UserRegistrationType;
}

export interface UserRegistrationRequest {
  email: string;
  password: string;
  phoneCallingCode?: string;
  phoneNumber?: string;
  registrationToken: string;
}

export interface UserRegistrationConfirmRequest {
  registrationToken: string;
  confirmationCode: string;
}

export interface UserRegistrationResendRequest {
  registrationToken: string;
}

export interface UserRegistrationConfirmResponse {
  error?: ConfirmUserRegistrationError;
  redirectUrl?: string;
}

export type RegisterUserResponse = Pick<
  UserRegistrationIntentResponse,
  'anonymizedConfirmationCodeRecipient' | 'confirmationMethod'
> & {
  redirectUrl?: string;
};
